import { render, staticRenderFns } from "./nice-user-thumb.vue?vue&type=template&id=4a8b547a&scoped=true"
import script from "./nice-user-thumb.vue?vue&type=script&lang=js"
export * from "./nice-user-thumb.vue?vue&type=script&lang=js"
import style0 from "./nice-user-thumb.vue?vue&type=style&index=0&id=4a8b547a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8b547a",
  null
  
)

export default component.exports